import React from "react"
import Slider from "react-slick"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import FsLightbox from "fslightbox-react"
import Plyr from "./plyr"
import { Play, Image } from "./icons"
import { PrevArrow, NextArrow } from "./icons"

const MachineGallery = ({ gallery, videoFile, label, darkMode, youtubeLink }) => {
  const [slideIndex, setSlideIndex] = React.useState(0)
  const [nav1, setNav1] = React.useState(null)
  const [nav2, setNav2] = React.useState(null)
  const slider1 = React.useRef(null)
  const slider2 = React.useRef(null)
  const [showPlyr, setShowPlyr] = React.useState(false)
  const [galleryLightbox, setGalleryLightbox] = React.useState({
    toggler: false,
    slide: 0,
  })

  React.useEffect(() => {
    setNav1(slider1?.current)
    setNav2(slider2?.current)
  }, [showPlyr])

  const settings = {
    speed: 600,
    fade: true,
    autoplay: false,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: "ease",
    swipe: false,
    pauseOnHover: true,
    arrows: false,
  }

  const settings2 = {
    swipeToSlide: true,
    infinite: true,
    adaptiveHeight: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    autoplay: false,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (oldIndex, newIndex) => setSlideIndex(newIndex),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  }

  const toggleShowPlyr = (e) => {
    setShowPlyr(!showPlyr)
  }

  const toggleLightbox = (index) => {
    console.log('lightbox called')
    setGalleryLightbox({
      toggler: !galleryLightbox.toggler,
      slide: index || slideIndex,
    })
  }

  return (
    <>
      <section className={`machine-gallery ${darkMode ? "dark" : ""}`}>
        <div className="machine-gallery__inner">
          {showPlyr && (
            <div id="video-component">
              <Plyr
                provider={videoFile ? "html5" : "youtube"}
                videoId={videoFile ? videoFile?.localFile?.publicURL : youtubeLink}
                url={videoFile ? videoFile?.localFile?.publicURL : youtubeLink}
                autoplay
                clickToPlay={true}
              />
            </div>
          )}
          {!showPlyr && gallery?.length > 0 && (
            <div id="main-slider">
              <div className="label">
                <span>{label}</span>
              </div>
              <Slider {...settings} asNavFor={nav2} ref={slider1}>
                {gallery?.map((el, i) => (
                  <div key={i} onClick={() => toggleLightbox(i + 1)} className='main-slider-item'>
                    <GatsbyImage
                      image={getImage(el.localFile)}
                      alt={el.altText ? el.altText : "Headland Technology"}
                    />
                  </div>
                ))}
              </Slider>
            </div>
          )}
        </div>
        <div className="machine-gallery__bottom-slider">
          {(videoFile || youtubeLink) && (
            <div onClick={toggleShowPlyr} className="video-btn-container">
              <div className="video-btn-container__overlay">
                <div className="icon-wrapper">
                  {showPlyr ? <Image /> : <Play />}
                </div>
              </div>
              <GatsbyImage
                image={getImage(gallery[0].localFile)}
                alt={
                  gallery[0].altText ? gallery[0].altText : "Headland Technology"
                }
              />
            </div>
          )}
          <div
            onClick={showPlyr ? toggleShowPlyr : undefined}
            className="slide2-container"
          >
            <Slider
              className={`slide2-container__slider ${videoFile || gallery.length > 4 ? "tile-container-padding" : ""
                }`}
              {...settings2}
              asNavFor={nav1}
              ref={slider2}
            >
              {gallery?.map((el, i) => (
                <React.Fragment key={i}>
                  <div style={{ position: "relative" }}
                    onClick={() => toggleLightbox(i + 1)}>
                    <GatsbyImage
                      key={i}
                      image={getImage(el.localFile)}
                      alt={el.altText ? el.altText : "Headland Technology"}
                    />
                    <div className={`${slideIndex === i ? "active" : ""}`}></div>
                  </div>
                </React.Fragment>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      {gallery?.length > 0 && (
        <FsLightbox
          toggler={galleryLightbox?.toggler}
          sources={gallery?.map((el) => el.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src)}
          slide={galleryLightbox?.slide}
          //slide={slideIndex}
          showThumbsOnMount={true}
        />
      )}
    </>

  )
}

export default MachineGallery
